import { render, staticRenderFns } from "./products.table.vue?vue&type=template&id=a139ea70&scoped=true&"
import script from "./products.table.vue?vue&type=script&lang=js&"
export * from "./products.table.vue?vue&type=script&lang=js&"
import style0 from "./products.table.vue?vue&type=style&index=0&id=a139ea70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a139ea70",
  null
  
)

export default component.exports